import React from "react";
const IconArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.5 5L4 10.5M4 10.5L9.5 16M4 10.5L16 10.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconArrowLeft;
